"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isExtraBedAvailable = void 0;
const isExtraBedAvailable = (rates) => {
    return rates.every((rate) => rate.extra_bed_available);
};
exports.isExtraBedAvailable = isExtraBedAvailable;
